// import { useState } from "react";
// import { Eye, EyeOff } from "lucide-react";
// import { toast } from "sonner";
// import { useUpdateEmployeePasswordMutation } from "../../redux/services/settingsRoleApi";

// export interface UpdatePasswordFormProps {
//   type: "company" | "individual";
// }

// export function UpdatePasswordForm({ type }: UpdatePasswordFormProps) {
//   const [currentPassword, setCurrentPassword] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);

//   const [updateEmployeePassword, { isLoading }] =
//     useUpdateEmployeePasswordMutation();

//   const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();


//     if (newPassword !== confirmPassword) {
//       toast.error("New passwords do not match");
//       return;
//     }

//     if (newPassword.length < 8) {
//       toast.error("New password must be at least 8 characters long");
//       return;
//     }

//     if (!/[A-Z]/.test(newPassword) || !/[a-z]/.test(newPassword)) {
//       toast.error("New password must contain both uppercase and lowercase letters");
//       return;
//     }

//     if (!/\d/.test(newPassword)) {
//       toast.error("New password must contain at least one number");
//       return;
//     }

//     if (newPassword === currentPassword) {
//       toast.error("New password must differ from your current password");
//       return;
//     }

//     try {
//       const res = await updateEmployeePassword({
//         old_password: currentPassword,
//         new_password: newPassword,
//         new_password_confirmation: confirmPassword,
//       }).unwrap();

//       toast.success(res?.data || "Password updated successfully!");
//       setCurrentPassword("");
//       setNewPassword("");
//       setConfirmPassword("");
//     } catch (error: any) {
//       const errorMsg =
//         error?.data?.message ||
//         error?.data?.error ||
//         "Failed to update password. Please try again.";
//       toast.error(errorMsg);
//     }
//   };

//   const requirements = [
//     {
//       id: "length",
//       label: "Minimum 8 characters",
//       valid: newPassword.length >= 8,
//     },
//     {
//       id: "different",
//       label: "Must differ from your current password",
//       valid: newPassword !== currentPassword && newPassword.length > 0,
//     },
//     {
//       id: "upperLower",
//       label: "Contains uppercase and lowercase letters",
//       valid: /[A-Z]/.test(newPassword) && /[a-z]/.test(newPassword),
//     },
//     {
//       id: "number",
//       label: "Includes at least one number",
//       valid: /\d/.test(newPassword),
//     },
//   ];

//   const inputClasses =
//     "w-full border rounded-lg px-3 py-2 text-sm pr-10 focus:outline-none focus:border-[#B9C3DB] focus:ring-2 focus:ring-[#B9C3DB]";

//   return (
//     <form onSubmit={handleSubmit} className="space-y-6">
//       {/* Current password */}
//       <div>
//         <label className="block text-sm font-medium mb-1">
//           Current Password
//         </label>
//         <div className="relative">
//           <input
//             type={showPassword ? "text" : "password"}
//             value={currentPassword}
//             onChange={(e) => setCurrentPassword(e.target.value)}
//             placeholder="Enter current password"
//             className={inputClasses}
//             required
//           />
//           <button
//             type="button"
//             onClick={() => setShowPassword(!showPassword)}
//             className="absolute right-3 top-2.5 text-gray-500"
//           >
//             {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//           </button>
//         </div>
//       </div>

//       {/* New password */}
//       <div>
//         <label className="block text-sm font-medium mb-1">New Password</label>
//         <div className="relative">
//           <input
//             type={showPassword ? "text" : "password"}
//             value={newPassword}
//             onChange={(e) => setNewPassword(e.target.value)}
//             placeholder="Enter new password"
//             className={inputClasses}
//             required
//           />
//           <button
//             type="button"
//             onClick={() => setShowPassword(!showPassword)}
//             className="absolute right-3 top-2.5 text-gray-500"
//           >
//             {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//           </button>
//         </div>
//       </div>

//       {/* Confirm new password */}
//       <div>
//         <label className="block text-sm font-medium mb-1">
//           Confirm New Password
//         </label>
//         <div className="relative">
//           <input
//             type={showPassword ? "text" : "password"}
//             value={confirmPassword}
//             onChange={(e) => setConfirmPassword(e.target.value)}
//             placeholder="Confirm new password"
//             className={inputClasses}
//             required
//           />
//           <button
//             type="button"
//             onClick={() => setShowPassword(!showPassword)}
//             className="absolute right-3 top-2.5 text-gray-500"
//           >
//             {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//           </button>
//         </div>
//       </div>

//       {/* password requirements */}
//       <div className="space-y-2">
//         {requirements.map((req) => (
//           <label
//             key={req.id}
//             className="flex items-center text-sm text-gray-700 gap-2"
//           >
//             <input
//               type="checkbox"
//               checked={req.valid}
//               readOnly
//               className="h-4 w-4 rounded border-gray-300"
//             />
//             <span className={req.valid ? "text-green-600" : "text-gray-500"}>
//               {req.label}
//             </span>
//           </label>
//         ))}
//       </div>

//       {/* submit button */}
//       <div className="flex justify-center">
//         <button
//           type="submit"
//           disabled={isLoading}
//           className={`w-[50%] bg-[#143887] text-white py-2 rounded-lg transition ${
//             isLoading
//               ? "opacity-70 cursor-not-allowed"
//               : "hover:bg-[#0e2b63] cursor-pointer"
//           }`}
//         >
//           {isLoading ? "Updating..." : "Update Password"}
//         </button>
//       </div>
//     </form>
//   );
// }

// export default UpdatePasswordForm;





import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { useUpdateEmployeePasswordMutation } from "../../redux/services/settingsRoleApi";

export interface UpdatePasswordFormProps {
  type: "company" | "individual";
}

export function UpdatePasswordForm({ type }: UpdatePasswordFormProps) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [updateEmployeePassword, { isLoading }] =
    useUpdateEmployeePasswordMutation();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("New passwords do not match");
      return;
    }

    if (newPassword.length < 8) {
      toast.error("New password must be at least 8 characters long");
      return;
    }

    if (!/[A-Z]/.test(newPassword) || !/[a-z]/.test(newPassword)) {
      toast.error("New password must contain both uppercase and lowercase letters");
      return;
    }

    if (!/\d/.test(newPassword)) {
      toast.error("New password must contain at least one number");
      return;
    }

    if (newPassword === currentPassword) {
      toast.error("New password must differ from your current password");
      return;
    }

    try {
      const res = await updateEmployeePassword({
        old_password: currentPassword,
        new_password: newPassword,
        new_password_confirmation: confirmPassword,
      }).unwrap();

      toast.success(res?.data || "Password updated successfully!");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      // } catch (error: any) {
      //   console.log("Password update error:", error);
      //   const errorMsg =
      //     error?.data?.message ||
      //     error?.data?.error ||
      //     error?.data?.errors?.old_password?.[0] ||
      //     error?.message ||
      //     "Failed to update password. Please try again.";
      //   toast.error(errorMsg);
      // }

    } catch (error: any) {
      console.log("Password update error:", error);

      const getRawMessage = (val: any): string => {
        if (!val) return "";
        if (typeof val === "string") return val;
        if (typeof val === "object" && val.message) return String(val.message);
        return "";
      };

      const errorMsg =
        getRawMessage(error?.data?.message) ||
        getRawMessage(error?.data?.error) ||
        error?.data?.errors?.old_password?.[0] ||
        getRawMessage(error?.message) ||
        "Failed to update password. Please try again.";

      toast.error(errorMsg);
    }
  };

  const requirements = [
    {
      id: "length",
      label: "Minimum 8 characters",
      valid: newPassword.length >= 8,
    },
    {
      id: "different",
      label: "Must differ from your current password",
      valid: newPassword !== currentPassword && newPassword.length > 0,
    },
    {
      id: "upperLower",
      label: "Contains uppercase and lowercase letters",
      valid: /[A-Z]/.test(newPassword) && /[a-z]/.test(newPassword),
    },
    {
      id: "number",
      label: "Includes at least one number",
      valid: /\d/.test(newPassword),
    },
  ];

  const inputClasses =
    "w-full border rounded-lg px-3 py-2 text-sm pr-10 focus:outline-none focus:border-[#B9C3DB] focus:ring-2 focus:ring-[#B9C3DB]";

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Current password */}
      <div>
        <label className="block text-sm font-medium mb-1">
          Current Password
        </label>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            placeholder="Enter current password"
            className={inputClasses}
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-2.5 text-gray-500"
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
      </div>

      {/* New password */}
      <div>
        <label className="block text-sm font-medium mb-1">New Password</label>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter new password"
            className={inputClasses}
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-2.5 text-gray-500"
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
      </div>

      {/* Confirm new password */}
      <div>
        <label className="block text-sm font-medium mb-1">
          Confirm New Password
        </label>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm new password"
            className={inputClasses}
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-2.5 text-gray-500"
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
      </div>

      {/* password requirements */}
      <div className="space-y-2">
        {requirements.map((req) => (
          <label
            key={req.id}
            className="flex items-center text-sm text-gray-700 gap-2"
          >
            <input
              type="checkbox"
              checked={req.valid}
              readOnly
              className="h-4 w-4 rounded border-gray-300"
            />
            <span className={req.valid ? "text-green-600" : "text-gray-500"}>
              {req.label}
            </span>
          </label>
        ))}
      </div>

      {/* submit button */}
      <div className="flex justify-center">
        <button
          type="submit"
          disabled={isLoading}
          className={`w-[50%] bg-[#143887] text-white py-2 rounded-lg transition ${isLoading
            ? "opacity-70 cursor-not-allowed"
            : "hover:bg-[#0e2b63] cursor-pointer"
            }`}
        >
          {isLoading ? "Updating..." : "Update Password"}
        </button>
      </div>
    </form>
  );
}

export default UpdatePasswordForm;